module.exports = __webpack_public_path__ + "static/media/YF54_2.74e9d36f.jpg";